import React from "react";
import { cloneDeep } from "lodash";
import OrderDTO from "@/dto/order/OrderDTO";
import SequenceNoGetter from "@/services/print/SequenceNoGetter";
import OrderMergeSplitStatus from "@/enum/OrderMergeSplitStatus";
import { useOrderManagementStore } from "../store/OrderManagementStore";

const useSequenceNoHandler = () => {
    const orderManagementStore = useOrderManagementStore();

    async function handleUpdateSequenceNo(orders: OrderDTO[]) {
        const sequenceNoMap = await SequenceNoGetter.get(orders);

        for (const order of orders) {
            const sequenceNo = sequenceNoMap[order.id];

            if (sequenceNo) {
                if (order.mergeSplitStatus === OrderMergeSplitStatus.MERGE_PARENT && order.childOrders) {
                    const newChildrenOrders = [];

                    order.childOrders.forEach((childOrder) => {
                        const cloneChildOrder = cloneDeep(childOrder);

                        cloneChildOrder.sequenceNo = sequenceNo;

                        newChildrenOrders.push(cloneChildOrder);
                    });

                    orderManagementStore?.table?.updateOrder(order.id, { sequenceNo, childOrders: newChildrenOrders });
                } else {
                    orderManagementStore?.table?.updateOrder(order.id, { sequenceNo });
                }
            }
        }
    }

    return { handleUpdateSequenceNo };
};

export default useSequenceNoHandler;
